<template>
    <div class="completed-works-page">
        <b-row class="my-2 align-items-center">
            <b-col cols="12" md="6" class="mb-2 mb-md-0">
                <b-input-group size="sm">
                    <b-form-input
                            v-model="filter"
                            debounce="200"
                            type="search"
                            id="filterInput"
                            placeholder="Введите для поиска"
                    ></b-form-input>
                    <b-input-group-append>
                        <b-form-select v-model="reportStatus" :options="reportStatusOptions"></b-form-select>
                        <b-form-select
                                v-model="archiveOnly"
                                :options="archiveScopeOptions"
                                aria-label="Статус объекта"
                        ></b-form-select>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
            <b-col cols="12" md="6">
                <div class="d-flex flex-wrap justify-content-md-end align-items-center">
                    <span class="text-success small mr-2 mb-2 mb-md-0">Найдено записей: {{ totalRows }}</span>
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                            class="my-0 mb-2 mb-md-0 mr-2"
                    ></b-pagination>
                    <div class="mb-2 mb-md-0">
                        <b-form-group
                                label="На странице"
                                label-cols="6"
                                label-size="sm"
                                label-for="perPageSelect"
                                class="mb-0 d-flex align-items-center"
                        >
                            <b-form-select
                                    v-model="perPage"
                                    id="perPageSelect"
                                    size="sm"
                                    :options="pageOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-table
                class="completed-works-table"
                responsive="sm"
                :fields="fields"
                :filter="filter"
                small
                striped
                :items="items"
                :current-page="currentPage"
                :per-page="perPage"
                @filtered="onFiltered"
                :busy="isBusy"
                sticky-header="80vh"
                :tbody-tr-class="reportRowClass"
        >
            <template #cell(report_status)="data">
                <b-badge v-if="isAnnulled(data.item)" variant="danger" :title="data.item.annulment_reason || ''">
                    АННУЛИРОВАН — НЕ УЧИТЫВАТЬ
                </b-badge>
                <b-badge v-else variant="success">Действующий</b-badge>
            </template>
            <template v-slot:cell(date_time_begin)="data">
                {{ Date.parse(data.item.date_time_begin) | moment("DD.MM.YYYY dd HH:mm")}}
            </template>
            <template v-slot:cell(date_time_end)="data">
                {{ Date.parse(data.item.date_time_end) | moment("DD.MM.YYYY dd HH:mm")}}
            </template>
            <template v-slot:cell(seconds_works)="data">
                <ul v-if="data.item.seconds_works">
                    <li :key="i" v-for="(item, i) in data.item.seconds_works.split(`-->`)">{{ item }}</li>
                </ul>
            </template>
            <template v-slot:cell(notes)="data">
                <ul v-if="data.item.notes">
                    <li :key="i" v-for="(item, i) in data.item.notes.split(`-->`)">{{ item }}</li>
                </ul>
            </template>
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle mx-2"></b-spinner>
                    <strong>Загрузка данных...</strong>
                </div>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        computed: {
            works() {
                return this.$store.state.completedWorksMainAndSeconds;
            },
            items() {
                const rows = this.$store.state.completedWorksMainAndSeconds || [];
                if (this.reportStatus === `active`) return rows.filter(row => !this.isAnnulled(row));
                if (this.reportStatus === `annulled`) return rows.filter(row => this.isAnnulled(row));
                return rows;
            }
        },
        data() {
            return {
                fields: [
                    {key: `report_status`, label: `Статус отчёта`, class: `completed-works-status-col`},
                    {
                        key: `shift_id`,
                        label: `Ид смены`,
                        class: `completed-works-shift-col`,
                        sortable: true
                    },
                    {
                        key: `date_time_begin`,
                        label: `Время начала смены`,
                        class: `completed-works-date-col`,
                        sortable: true
                    },
                    {
                        key: `date_time_end`,
                        label: `Время окончания смены`,
                        class: `completed-works-date-col`,
                        sortable: true
                    },
                    {
                        key: `building_name`,
                        label: `Имя объекта`,
                        class: `completed-works-object-col`,
                        sortable: true
                    },
                    {
                        key: `group_name`,
                        label: `Имя группы работ`,
                        class: `completed-works-group-col`,
                        sortable: true
                    },
                    {
                        key: `work_name`,
                        label: `Имя работы`,
                        class: `completed-works-work-col`,
                        sortable: true
                    },
                    {
                        key: `value`,
                        label: `Выполнено`,
                        class: `completed-works-value-col`,
                        sortable: true
                    },
                    {
                        key: `unit_of_measurement`,
                        label: `Единица измерения`,
                        class: `completed-works-unit-col`,
                        sortable: true
                    },
                    {
                        key: `person_counts`,
                        label: `Задействовано рабочих в данной работе`,
                        class: `completed-works-people-col`,
                        sortable: true
                    },
                    {
                        key: `seconds_works`,
                        label: `Вторичные работы`,
                        class: `completed-works-secondary-col`,
                        sortable: true
                    },
                    {
                        key: `notes`,
                        label: `Замечания`,
                        class: `completed-works-notes-col`,
                        sortable: true
                    }
                ],
                filter: null,
                filterOn: [],
                perPage: 100,
                pageOptions: [5, 10, 15, 20, 100, 200],
                totalRows: 1,
                currentPage: 1,
                isBusy: true,
                archiveOnly: false,
                archiveScopeOptions: [
                    {value: false, text: `Действующие объекты`},
                    {value: true, text: `Архив объектов`}
                ],
                reportStatus: `all`,
                reportStatusOptions: [
                    {value: `all`, text: `Все отчёты`},
                    {value: `active`, text: `Действующие`},
                    {value: `annulled`, text: `Аннулированные`}
                ]
            }
        },
        async mounted() {
            await this.loadWorks();
        },
        methods: {
            async loadWorks() {
                this.isBusy = true;
                try {
                    await this.$store.dispatch(`getCompletedWorksMainAndSeconds`, this.archiveOnly);
                    await this.$nextTick();
                    this.totalRows = this.items.length;
                    this.currentPage = 1;
                } finally {
                    this.isBusy = false;
                }
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
            isAnnulled(item) {
                return Boolean(item && item.annulled_at);
            },
            reportRowClass(item) {
                return this.isAnnulled(item) ? `legacy-report-row--annulled` : ``;
            },
            format(val) {
                return val.replace(`.`, `/`);
            }
        },
        watch: {
            archiveOnly() {
                this.loadWorks();
            },
            reportStatus() {
                this.$nextTick(() => {
                    this.totalRows = this.items.length;
                    this.currentPage = 1;
                });
            }
        },
        name: "CompletedWorks"
    }
</script>

<style scoped>

.completed-works-page {
    min-width: 0;
    overflow-x: hidden;
}

.completed-works-table,
.completed-works-table >>> table {
    width: 100%;
    table-layout: fixed;
}

.completed-works-table >>> th,
.completed-works-table >>> td {
    padding: .3rem;
    overflow-wrap: anywhere;
    vertical-align: middle;
}

.completed-works-table >>> ul {
    margin: 0;
    padding-left: 1rem;
}

.completed-works-table >>> .completed-works-status-col .badge {
    white-space: normal;
}

.completed-works-table >>> .completed-works-status-col { width: 9%; }
.completed-works-table >>> .completed-works-shift-col { width: 6%; }
.completed-works-table >>> .completed-works-date-col { width: 8%; }
.completed-works-table >>> .completed-works-object-col { width: 12%; }
.completed-works-table >>> .completed-works-group-col { width: 10%; }
.completed-works-table >>> .completed-works-work-col { width: 10%; }
.completed-works-table >>> .completed-works-value-col { width: 7%; }
.completed-works-table >>> .completed-works-unit-col { width: 8%; }
.completed-works-table >>> .completed-works-people-col { width: 9%; }
.completed-works-table >>> .completed-works-secondary-col { width: 7%; }
.completed-works-table >>> .completed-works-notes-col { width: 6%; }

>>> tr.legacy-report-row--annulled > td {
    background: #fff3f3;
    color: #721c24;
}

</style>
